import React, { useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import myVideo1 from '../../assets/videos/video_1.mp4';
import myVideo2 from '../../assets/videos/video_2.mp4';
import myVideo3 from '../../assets/videos/video_3.mp4';
import '../../index.css';
// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const AwardsSection = () => {
  const sectionRef = useRef(null);

  // Awards data
  const awards = [
    {
      id: 1,
      video: myVideo1,
      title: 'Video 1',
      isVideo: true,
      subtitle: 'Awarded for excellence in customer service and product quality.'
    },
    {
      id: 2,
      video: myVideo2,
      title: 'Video 2',
      isVideo: true,
      subtitle: 'Recognized for our commitment to sustainable farming practices.'
    },
    {
      id: 3,
      video: myVideo3,
      title: 'Video 3',
      isVideo: true,
      subtitle: 'Honored for our innovative solutions in agricultural technology.'
    }
  ];

  return (
    <section
      ref={sectionRef}
      className="py-[42px] md:py-12 lg:py-[100px] bg-white"
    >
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 md:gap-[20px]">
          {awards.map((award) => (
            <div
              key={award.id}
              className="flex flex-col items-center group cursor-pointer transition-transform duration-300 hover:-translate-y-2"
            >
              {/* Award Image or Video */}
              <div
                className="award-media w-full h-[300px] sm:h-[300px] md:h-[340px] lg:h-[340px] max-w-full rounded-[16.39px] overflow-hidden mb-4 md:mb-4 shadow-md transition-all duration-300 group-hover:shadow-lg"
                style={{ maxWidth: '100%' }}
              >
                {award.image ? (
                  <img
                    src={award.image}
                    alt={award.subtitle}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <video
                    src={award.video}
                    controls
                    className="w-full h-full object-cover"
                  />
                )}
              </div>

              {/* Award Text */}
              <div className="w-full px-2 md:px-0">
                <h3 className="award-title manrope-font font-medium text-[18px] sm:text-[20px] md:text-[21.86px] leading-[1.5] md:leading-[32.79px]">
                  {award.title}
                </h3>
                <p className="award-subtitle manrope-font font-normal text-[16px] sm:text-[18px] md:text-[19.12px] leading-[1.5] md:leading-[28.69px] text-[#70826B]">
                  {award.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsSection;
